import tpLight from '@sixfold/design-tokens/build/transporeon/json/variables.json';
import React__default from 'react';
import { ThemeContext } from './theme_provider.js';

const useTheme = () => {
    const { currentTheme, themes, onThemeChange = () => null, getIconPath } = React__default.useContext(ThemeContext);
    return React__default.useMemo(() => {
        const variables = themes && currentTheme ? themes[currentTheme].variables : tpLight;
        return { currentTheme, variables, themes, setTheme: onThemeChange, getIconPath };
    }, [currentTheme, themes, onThemeChange, getIconPath]);
};

export { useTheme };
